// 首页
import request from '@/utils/request'

// 设备管理主页························start
// 所有数据
export function findGeofenceDeviceList(params) {
  return request({
    url: '/v3/manager/geofence/findGeofenceDeviceList',
    method: 'post',
    data: params
  })
}
// 下拉框客户名称
export function listByCompanyParentId(params) {
  return request({
    url: 'v3/user/company/listByCompanyParentId',
    method: 'post',
    data: params
  })
}
// 公司信息下拉框
export function getList(params) {
  return request({
    url: '/v3/user/company/list',
    method: 'post',
    data: params
  })
}
// 修改电子围栏
export function updateGnssGeofenceStatus(params) {
  return request({
    url: '/v3/manager/geofence/updateGnssGeofenceStatus',
    method: 'post',
    data: params
  })
}
// 设备管理主页························end

// 电子围栏························start
// 设备基本信息
export function findDeviceInfo(params) {
  return request({
    url: '/v3/report/findDeviceInfo',
    method: 'post',
    data: params
  })
}
// 新增电子围栏
export function addGnssGeofence(params) {
  return request({
    url: '/v3/manager/geofence/addGnssGeofence',
    method: 'post',
    data: params
  })
}
// 获取定位
export function getGNSSLastByMcuID(params) {
  return request({
    url: '/v3/location/getGNSSLastByMcuID',
    method: 'post',
    data: params
  })
}
// 获取电子围栏
export function getGnssGeofenceByMcuId(params) {
  return request({
    url: '/v3/manager/geofence/getGnssGeofenceByMcuId',
    method: 'post',
    data: params
  })
}
// 获取警告信息
export function listWarningPushMsg(params) {
  return request({
    url: '/v3/report/listWarningPushMsg',
    method: 'post',
    data: params
  })
}
// 设备信息
export function getRealTimeInfo2(param) {
  return request({
    url: '/v3/openApi/internalAccess/getRealTimeInfo2/' + param.sn,
    method: 'get'
    // params: param
  })
}
// 电子围栏························end

// 轨迹回放························start
export function listLocationData(params) {
  return request({
    url: '/v3/location/listLocationData',
    method: 'post',
    data: params,
    responseType: 'arraybuffer'
  })
}
// 轨迹回放························end

export function updateGnssConfig(params) {
  return request({
    url: '/v3/location/updateGnssConfig',
    method: 'post',
    // headers: { 'token': 'nmamtf' },
    data: params

  })
}
